<div class="store-bar">
  <div class="store-bar__inner">
    <ul class="store-bar__figures">
      <li class="store-bar__figure">
        <span class="store-bar__label">{{ 'clicStore.myPointsLabel' | translate }}</span>
        <strong class="store-bar__value">
          <ng-container *ngIf="unknown; else knownBalance">
            <span class="store-bar__unavailable">{{ 'clicStore.balanceUnavailable' | translate }}</span>
          </ng-container>
          <ng-template #knownBalance>
            <ng-container *ngIf="!loading; else loadingValue">{{ balance | number }}</ng-container>
            <span class="store-bar__unit">{{ 'clicStore.pointsUnit' | translate }}</span>
          </ng-template>
        </strong>
      </li>

      <li class="store-bar__figure">
        <span class="store-bar__label">{{ 'clicStore.willBeDebited' | translate }}</span>
        <strong class="store-bar__value store-bar__value--debit">
          <span *ngIf="hasDebit" aria-hidden="true">&minus;</span>{{ debit | number }}
          <span class="store-bar__unit">{{ 'clicStore.pointsUnit' | translate }}</span>
        </strong>
      </li>

      <li class="store-bar__figure">
        <span class="store-bar__label">{{ 'clicStore.balanceAfter' | translate }}</span>
        <strong class="store-bar__value store-bar__value--credit">
          <ng-container *ngIf="!loading; else loadingValue">{{ balanceAfter | number }}</ng-container>
          <span class="store-bar__unit">{{ 'clicStore.pointsUnit' | translate }}</span>
        </strong>
      </li>
    </ul>

    <div class="store-bar__actions">
      <a class="store-bar__statement" [routerLink]="['/exchange-points']">
        {{ 'clicStore.checkStatement' | translate }}
      </a>

      <button type="button" class="store-bar__cart" (click)="openCart.emit()"
        [attr.aria-label]="('clicStore.cart' | translate) + ': ' + cartCount">
        <span class="store-bar__cart-text">{{ 'clicStore.cart' | translate }}</span>
        <span class="store-bar__badge" *ngIf="cartCount > 0">{{ cartCount }}</span>
      </button>
    </div>
  </div>
</div>

<ng-template #loadingValue><span class="store-bar__value--muted">&mdash;</span></ng-template>
